.container {
  width: auto;
  height: auto;
}
